import { useEffect } from 'react';
import { Box, Grid } from '@chakra-ui/react';
import { useSetAtom } from 'jotai';
import { Label } from 'components/elements/Label';
import { Text } from 'components/elements/Text';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { InfoModal } from 'components/widgets/InfoModal';
import { useInView } from 'hooks/useInView';
import { UseModalResult } from 'hooks/useModal';
import { statusSectionInViewAtom } from 'state/contactEnrichment';
import { formatDate } from 'utils/date';
import type { Activity } from 'types';

type Props = {
  activities?: Activity[];
  Skeleton: UseModalResult<object>['Skeleton'];
};

// TODO: Fix activities
export const ModalStatus = ({ activities, Skeleton }: Props) => {
  const { ref, inView } = useInView<HTMLDivElement>();
  const setStatusSectionInView = useSetAtom(statusSectionInViewAtom);

  // Re-arm on mount and clear on unmount so the trigger never leaks a stale
  // `true` into the next document that opens.
  useEffect(() => {
    setStatusSectionInView(false);

    return () => setStatusSectionInView(false);
  }, [setStatusSectionInView]);

  useEffect(() => {
    if (inView) {
      setStatusSectionInView(true);
    }
  }, [inView, setStatusSectionInView]);

  return (
    <Box ref={ref}>
      <InfoModal.Row alignLabelTop>
        <Label>Status</Label>
        <InfoModal.RowDetails>
          <Grid templateColumns="1fr auto" gridGap={3} width="100%">
            <Skeleton variant="text" noOfLines={4}>
              <FlexColumn sx={{ gap: '10px' }}>
                {activities?.map(({ status, date }) => {
                  return (
                    <FlexRow justifyContent="space-between" sx={{ gap: '56px' }}>
                      <Text
                        sx={{
                          textTransform: 'capitalize',
                          fontSize: '12px',
                          fontWeight: '600',
                          lineHeight: '14px',
                          letterSpacing: '-0.02em',
                          width: '45%',
                        }}
                      >
                        {status}
                      </Text>
                      <Text
                        sx={{
                          fontSize: '12px',
                          lineHeight: '14px',
                          letterSpacing: '-0.02em',
                          fontStyle: 'italic',
                          opacity: '50%',
                          width: '50%',
                        }}
                      >
                        {formatDate(date)}
                      </Text>
                    </FlexRow>
                  );
                })}
              </FlexColumn>
            </Skeleton>
          </Grid>
        </InfoModal.RowDetails>
      </InfoModal.Row>
    </Box>
  );
};
